const TokenKey = "study-dot-ooowin-token";
const PhoneKey = "study-dot-ooowin-phone"
const NickNamekey = "study-dot-ooowin-nickname"
const Constants = {
    TokenKey,
    PhoneKey,
    NickNamekey
}
export default Constants;